import { render, staticRenderFns } from "./Informacoes.vue?vue&type=template&id=14bf6dee&scoped=true&"
import script from "./Informacoes.vue?vue&type=script&lang=js&"
export * from "./Informacoes.vue?vue&type=script&lang=js&"
import style0 from "./Informacoes.vue?vue&type=style&index=0&id=14bf6dee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bf6dee",
  null
  
)

export default component.exports